import { Component, Input, OnInit } from '@angular/core';
import { PromotionsService } from 'src/app/api/promotions.service';
import { PromotionStatus, VerifyAndEarnPromotion } from 'src/app/models/promotions';
import { TierOneStatusType } from 'src/app/models/tier-one';

export enum VerifyAndEarnPromotionStatus {
  Verification = 'Verification',
  RetryVerification = 'RetryVerification',
  InReview = 'InReview',
  Deposit = 'Deposit',
  Disabled = 'Disabled'
}

@Component({
  selector: 'promotions-notification',
  templateUrl: './promotions-notification.component.html',
  styleUrls: ['./promotions-notification.component.scss']
})
export class PromotionsNotificationComponent implements OnInit {
  VerifyAndEarnPromotionStatus = VerifyAndEarnPromotionStatus;

  @Input() asterisk = false;

  verifyAndEarn: VerifyAndEarnPromotion;
  status = VerifyAndEarnPromotionStatus.Disabled;

  constructor(private promotionsService: PromotionsService) { }

  ngOnInit(): void {
    this.inviteAndEarn();
  }

  inviteAndEarn() {
    this.promotionsService.verifyAndEarnWithTierOne().subscribe(response => {
      this.verifyAndEarn = response.verifyAndEarn;
     this.setVerifyAndEarnStatus(response.verifyAndEarn, response.tierOneStatus);
    }, (err) => {
      this.verifyAndEarn = null;
      this.status = VerifyAndEarnPromotionStatus.Disabled;
    });
  }

  setVerifyAndEarnStatus(verifyAndEarn: VerifyAndEarnPromotion, tierOneStatus: TierOneStatusType) {
    // Promotion Enabled
    if (verifyAndEarn?.status === PromotionStatus.ENABLED) { 
      
      // Draft (Verify)
      if (!tierOneStatus || tierOneStatus === TierOneStatusType.DRAFT) {
        this.status = VerifyAndEarnPromotionStatus.Verification
      
      // Submit Again
      } else if ([TierOneStatusType.BAD_QUALITY_DOCUMENT_UPLOADED, TierOneStatusType.INVALID_DOCUMENT_UPLOADED, TierOneStatusType.PENDING_DOCUMENTS].includes(tierOneStatus)) {
        this.status = VerifyAndEarnPromotionStatus.RetryVerification

      // In Progress (No action)
      } else if ([TierOneStatusType.IN_PROGRESS, TierOneStatusType.MANUAL_REVIEW].includes(tierOneStatus)) {
        this.status = VerifyAndEarnPromotionStatus.InReview;

        // Approved (show deposit)
      } else if ([TierOneStatusType.APPROVED, TierOneStatusType.FORCE_APPROVED].includes(tierOneStatus)) {
        this.status = VerifyAndEarnPromotionStatus.Deposit;
      
      // Not Allowed (Disable)
      } else {
        this.status = VerifyAndEarnPromotionStatus.Disabled;
      }

    // Promotion Disabled (Disable)
    } else {
      this.status = VerifyAndEarnPromotionStatus.Disabled;
    }
  }
}
